var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var AdaptConfig_1;
import { ToolType } from '@symon-ai/wisepipe-base-pipe';
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './adaptColumn'; // force import for JsonSchemaV2
import { ToolCategories } from './toolCategories';
import { ToolConfig } from './toolConfig';
import { ToolConfigInfo } from './toolConfigInfo';
import { ToolScopeBuilder } from './toolScopeBuilder';
import { ToolValidationResult } from './validation/toolValidationResult';
import { validateSourceWithDetail } from './validation/validateHelper';
import { adaptConfigSchemaValidation } from '../validations.generated';
export const adaptConfigSchema = {
    $id: 'urn:wisepipe-common-pipe:AdaptConfig',
    type: 'object',
    properties: {
        columns: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:AdaptColumn' },
            minItems: 1,
            maxItems: 1000,
            uniqueItemProperties: ['oldName', 'newName']
        }
    },
    required: ['columns']
};
let AdaptConfig = AdaptConfig_1 = class AdaptConfig extends ToolConfig {
    constructor(columns, customFormats) {
        super(ToolType.ADAPT, customFormats);
        this.columns = columns;
        JSON.validate(this, AdaptConfig_1);
    }
    // eslint-disable-next-line class-methods-use-this
    get in() {
        return AdaptConfig_1.in;
    }
    // eslint-disable-next-line class-methods-use-this
    get out() {
        return AdaptConfig_1.out;
    }
    // eslint-disable-next-line class-methods-use-this
    get ins() {
        return AdaptConfig_1.ins;
    }
    // eslint-disable-next-line class-methods-use-this
    get outs() {
        return AdaptConfig_1.outs;
    }
    static get in() {
        return AdaptConfig_1.ins[0];
    }
    static get out() {
        return AdaptConfig_1.outs[0];
    }
    static get ins() {
        return ['default'];
    }
    static get outs() {
        return ['default'];
    }
    static get info() {
        return new ToolConfigInfo(ToolType.ADAPT.split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '), [ToolCategories.ORGANIZE], this.ins, this.outs, ['change', 'rename'], true);
    }
    getOutput(iConfigHelper, ins) {
        const tsb = new ToolScopeBuilder(ins);
        const source = ins.schemas.at(this.in);
        const adaptedColumns = new Map();
        const newNames = [];
        this.columns.forEach((c) => {
            adaptedColumns.set(c.oldName, c);
            newNames.push(c.newName);
        });
        const exp = tsb.export(this.out);
        const clearColumnFormats = new Map();
        source.forEach((s) => {
            if (adaptedColumns.has(s.name)) {
                const adaptColumn = adaptedColumns.get(s.name);
                exp.changeType(this.in, s, adaptColumn.newType, true, adaptColumn.newName);
                if (s.type !== adaptColumn.newType) {
                    clearColumnFormats.set(adaptColumn.newName, undefined);
                }
            }
            else {
                let renameCount = 2;
                let renamed = s.name;
                while (newNames.includes(renamed)) {
                    // Something else has been renamed to this column. Add a suffix.
                    renamed = `${s.name} ${renameCount++}`;
                }
                newNames.push(renamed);
                if (renamed === s.name) {
                    exp.copy(this.in, s, false, false);
                }
                else {
                    exp.copy(this.in, s, false, false, undefined, renamed);
                }
            }
        });
        exp.setColumnFormats(clearColumnFormats).initializeColumnFormats().setColumnFormats(this.customFormats);
        return tsb.build();
    }
    isValidForCalc(iConfigHelper, scope) {
        const toolValidationResult = this.getToolValidationResult(iConfigHelper, scope);
        return toolValidationResult.validationState;
    }
    getToolValidationResult(iConfigHelper, scope) {
        const source = scope.schemas.at(this.in);
        if (!source) {
            return ToolValidationResult.getMissingSourceColumnsResult();
        }
        const inputs = new Set(this.columns.map((c) => c.oldName));
        // check there are no period type columns in the inputs
        for (const columnName of inputs) {
            const column = source.find((c) => c.name === columnName);
            if (column && column.type === 'period') {
                return ToolValidationResult.getInvalidResult(`Column ${columnName} is of type period. Cannot adapt period columns.`);
            }
        }
        const sourceValidationResult = validateSourceWithDetail(source, inputs, []);
        return ToolValidationResult.getResultFromSourceValidation(sourceValidationResult);
    }
};
AdaptConfig = AdaptConfig_1 = __decorate([
    JsonSchemaV2(adaptConfigSchema, adaptConfigSchemaValidation),
    JsonDiscriminatorValue(ToolType.ADAPT)
], AdaptConfig);
export { AdaptConfig };
//# sourceMappingURL=adaptConfig.js.map